import React from 'react';
import useEsiPortal from '../../hooks/useEsiPortal';

export default function PlansAlwaysOn() {
  const esiPortalRef = useEsiPortal('esi-plans-always-on');

  return <div ref={esiPortalRef} data-testid="plans-always-on" />;
}
